{
    "ford": {
        "Text": "#ffffff",
        "BG": "#1967b0",
        "Button": "#1967b0",
        "Circle": "#1967b0",
        "Header": "/contents/images/Header-Ford-Ensure.png",
        "Logo": "assets/images/logo-ford-insure.png"
    },
    "mazda": {
        "Text": "#ffffff",
        "BG": "#231f20",
        "Button": "#231f20",
        "Circle": "#231f20",
        "Header": "/contents/images/Header-MPI.png",
        "Logo": "assets/images/logo-mazda-insure.png"
    },
    "nissan": {
        "Text": "#ffffff",
        "BG": "#000000",
        "Button": "#c3002f",
        "Circle": "#000000",
        "Header": "/contents/images/Header-Nissan.png",
        "Logo": "assets/images/logo-nissan-insure.png"
    },
    "insure": {
        "Text": "#000000",
        "BG": "#f4f4f4",
        "Button": "#1173b2",
        "Circle": "#4882c2",
        "Header": "/contents/images/Header-TISCO-Insure.png",
        "Logo": "assets/images/logo-insure.png"
    },
    "gwm": {
        "Text": "#ffffff",
        "BG": "#ffffff",
        "Button": "#21242d",
        "Circle": "#231f20",
        "Header": "/contents/images/Header-GWM-Insurance.png",
        "Logo": "assets/images/logo-gwm2.png"
    }
}